import { Location } from '../../apis/dtos';
import { Typography, Box, Stack } from '@mui/material';
import { useTranslation } from '@chr/online-shared-ui-localizations';
import { FormatLocation } from '../../utilities/display-utilities';

interface ShipmentDetailsLocationProps {
  /** The title to display inside the item */
  title: string;
  /** Location */
  location: Location;
	/** Location Label*/
  locationLabel: string;
  /** Dates for the Location*/
  values: ShipmentDetailValue[];
  //** Indicates whether or not this should be formatted for a mobile screen */
  isMobileScreen: boolean;
  //** The desired width */
  width: string;
}

export interface ShipmentDetailValue {
  //** The value's label*/
  label: string;
  /** The value*/
  value?: string;
}

export const ShipmentDetailsLocation = ({ title, locationLabel, location, values, isMobileScreen, width }: ShipmentDetailsLocationProps) => {
  const translate = useTranslation();
  const showLocation: boolean = location !== null && location !== undefined;

	return (
    <Box
      data-testid='shipment-detail-location-box'
      sx={{
        width: isMobileScreen ? '95%' : width,
        background: '#F6F7F8',
        border: isMobileScreen ? '' : '1px solid #E5E6E7',
        borderRadius: isMobileScreen ? '' : '4px',
        padding: isMobileScreen ? '5px' : '24px',
      }}
    >
			<Typography variant='subtitle1'>
				{ translate(title) }
      </Typography>
			<Stack
        direction={isMobileScreen ? 'column' : 'row'}
        spacing={2}
        alignItems={'flex-start'}
        justifyContent={'flex-start'}
        sx={{ marginTop: 2, width: '100%' }}
      >
				<Stack direction={isMobileScreen ? 'row' : 'column'} spacing={isMobileScreen ? 2 : 0 } justifyContent={isMobileScreen ? 'space-between' : 'flex-start'} width={'100%'}>
					<Typography variant='body1'>
						{ translate(locationLabel) }
					</Typography>
					<Typography variant='h3' sx={{ textAlign: isMobileScreen ? 'right' : 'left' }}>
            {
              showLocation ? FormatLocation(location) : ''
            }
					</Typography>
				</Stack>
        {
          values && values.map((labeledValue, index) => {
            return (
              <Stack
                key={`labeled-value-${index}`}
                direction={isMobileScreen ? 'row' : 'column'}
                justifyContent={isMobileScreen ? 'space-between' : 'flex-start'}
                width={'100%'}
              >
                <Typography variant='body1' sx={{marginRight: '16px'}}>
                  {translate(labeledValue.label)}
                </Typography>
                <Stack direction={isMobileScreen ? 'column' : 'row'} textAlign='right'>
                  <Typography variant='h3'>
                    {labeledValue.value}
                  </Typography>
                </Stack>
              </Stack>
            );
          })
        }
			</Stack>
		</Box>
	);
}
